module.exports = __webpack_public_path__ + "img/competence_icon_rjc.20c3068.svg";